<script>
import WebLinkMixin from '@/mixins/weblink'
import IconPlay from '@/components/IconPlay.vue'
import vueSignature from 'vue-signature'

import { SELLING_REGIONS, OPPORTUNITY_TYPES_IDS, OPPORTUNITY_EXPORT_TYPES, OPPORTUNITY_EXPORT_SECTIONS_IDS } from '@/constants'
import { helpers } from '@/helpers'
import ImageZoom from '@/components/ImageZoom.vue'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

const INFO_EXTENSION_TAB = 'info-extension-tab'
const DAY_EXTENSION_TAB = 'day-extension-tab'

export default {
  name: 'WebLinkTrafalgarRiver',
  mixins: [WebLinkMixin],
  data () {
    return {
      currentSlide: 0,
      tabs: {
        INFO_EXTENSION_TAB,
        DAY_EXTENSION_TAB
      },
      selectedExtensionTab: INFO_EXTENSION_TAB,
      selectedExtension: null,
      selectedCategory: null,
      isModalExtensionDetail: false,
      isModalCategoryDetail: false,
      isModalTermsAndConditionsToggle: false,
      isModalBookMyGroupSuccessToggle: false,
      isModalBookMyGroupToggle: false,
      modal: 0,
      signatureBoolean: true,
      signatureName: false,
      signaturePayment: false,
      signatureCondition: false,
      signatureNumber: false,
      signatureBox: false,
      constants: {
        SELLING_REGIONS,
        OPPORTUNITY_TYPES_IDS,
        OPPORTUNITY_EXPORT_TYPES,
        OPPORTUNITY_EXPORT_SECTIONS_IDS
      },
      helpers: helpers
    }
  },
  methods: {
    categoryPhoto (category) {
      if (category.photos.length) return category.photos[0]
      return "/weblinks/trafalgar/img/day-img.jpg";
    },
    getItineraryDayClassByIndex (index = 1) {
      const classByIndex = {
        1: 'red',
        2: 'green',
        0: 'yellow'
      }
      return classByIndex[Math.ceil(index / 2) % 3]
    },
    selectExtensionTab (tab) {
      this.selectedExtensionTab = tab
    },
    getFromPrice (extension) {
      const date = new Date()
      const year = date.getFullYear().toString();
      const pricing = extension.extensionpricing.find(ep => ep.Year === year);
      if (pricing) return pricing.PricePerPerson;
      return "";
    },
    fillQuoteRequest (extension) {
      this.description = "Hello, I would like a quote for extension " + extension.extensiontitle.toUpperCase();

      const element = document.getElementById("contact");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    toggleExtensionDetailModal (extension = null) {
      if (extension) {
        if (extension.is_child) {
          const url = location.protocol + "//" + location.host + "/weblink/" + extension.uuid;
          window.open(url, "_blank");
          return;
        }
      }

      this.isModalExtensionDetail = extension != null;
      this.selectedExtension = extension;
      document.body.classList.toggle(
        'modal-open',
        this.isModalExtensionDetail
      )
      if (extension) {
        document.body.classList.add(
          'modal-open',
          this.isModalExtensionDetail
        )
      }
    },
    toggleCategoryShipDetailModal (category = null) {
      this.isModalCategoryDetail = category != null;
      this.selectedCategory = category;
      document.body.classList.toggle(
        'modal-open',
        this.isModalExtensionDetail
      )
      if (category) {
        document.body.classList.add(
          'modal-open',
          this.isModalCategoryDetail
        )
      }
    },
    toggleTermsAndConditionsModal (i = 0) {
      this.modal = i === 1 ? 1 : 0
      this.isModalTermsAndConditionsToggle = !this
        .isModalTermsAndConditionsToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalTermsAndConditionsToggle
      )
      if (this.modal === 1) {
        this.toggleBookMyGroupModal()
        document.body.classList.add(
          'modal-open',
          this.isModalTermsAndConditionsToggle
        )
      }

      this.checkTermConditionScroll(this.isModalTermsAndConditionsToggle)
    },
    toggleBookMyGroupModal () {
      this.isModalBookMyGroupToggle = !this.isModalBookMyGroupToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupToggle
      )

      setTimeout(() => {
        let canvas = document.querySelector('.signature-gold canvas')
        if (canvas) {
          let parentWidth = canvas.parentElement.offsetWidth
          let parentHeight = canvas.parentElement.offsetHeight
          canvas.height = parentHeight
          canvas.width = parentWidth
        }
      }, 500)
    },
    toggleBookMyGroupSuccessModal () {
      this.isModalBookMyGroupSuccessToggle = !this
        .isModalBookMyGroupSuccessToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupSuccessToggle
      )
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    handleSaveSignature () {
      this.signatureName = false
      this.signaturePayment = false
      this.signatureCondition = false
      this.signatureNumber = false
      this.signatureBox = false
      if (
        this.signature.accepted_conditions === false ||
        this.signature.name === '' ||
        this.signature.payment_amount === '' ||
        this.signature.number_of_guests === ''
      ) {
        this.message = 'All the fields are required.'
        if (this.signature.accepted_conditions === false) {
          this.signatureCondition = true
        }
        if (this.signature.name === '') {
          this.signatureName = true
        }
        if (this.signature.payment_amount === '') {
          this.signaturePayment = true
        }
        if (this.signature.number_of_guests === '') {
          this.signatureNumber = true
        }
        return false
      }
      if (this.$refs.signature.isEmpty()) {
        this.message = 'Please fill your signature.'
        this.signatureBox = true
        return false
      }
      this.signature.uuid = this.$route.params.uuid
      this.signature.accepted_conditions = 1
      this.signature.image = this.$refs.signature.save()
      this.disableButton = true
      this.message = null
      this.sendSignature(this.signature)
        .then(response => {
          if (response.data && response.status === 200 && response.data.status) {
            this.cleanForm()
            this.disableButton = true
            this.hasSignature = true
            this.toggleBookMyGroupSuccessModal()
            this.toggleBookMyGroupModal()
          } else {
            this.message = 'Something went wrong, please try again.'
            this.isSending = false
            this.isCompleted = true
            this.disableButton = false
          }
        })
        .catch(error => {
          const hasMessage = error && error.response && error.response.data && error.response.data.message
          this.message = hasMessage || 'Something went wrong, please try again.'
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
          this.disableButton = false
        })
        .finally(() => {})
    },
    clear () {
      var _this = this
      _this.$refs.signature.clear()
    },
    undo () {
      var _this = this
      _this.$refs.signature.undo()
    },
    cleanForm () {
      this.signature.id = null
      this.signature.parent = null
      this.signature.name = ''
      this.signature.last_name = ''
      this.signature.user_agent = ''
      this.signature.payment_amount = ''
      this.signature.traveler_email = ''
      this.signature.number_of_guests = ''
      this.signature.accepted_conditions = 0
      this.signature.image = ''
      this.clear()
    },
    handleInput (e, value) {
      if (value !== '' || value) {
        e.target.classList.remove('active')
      }
    }
  },
  components: {
    ImageZoom,
    IconPlay,
    vueSignature
  },
  mounted () {
    // this.signature.traveler_email = this.data.data.email_owner
    //   ? this.data.data.email_owner
    //   : ''
    this.signature.parent = this.data.data.itineraries.id
      ? this.data.data.itineraries.id
      : ''

    this.getSignature(this.signature.parent)
  },
  computed: {
    categories () {
      const categories = this.availableSailings.flatMap(as => as.categories);

      return Object.values(
        categories.reduce((acc, data) => {
          const { name, staterooms_available } = data;
          const index = name.lastIndexOf(" ");
          const group = index > 0 ? name.substring(0, index) : name;
          acc[group] = acc[group] || { ...data, group, staterooms_available: 0 };
          acc[group].staterooms_available += staterooms_available;
          return acc;
        }, {})
      );
    },
    availableExtensions() {
      const extensions = this.d.itineraries.extensions || [];
      const opportunities = this.d.related_opportunities.map((op) => {
        return {
          uuid: op.uuid,
          extensionimage: op.url_image || '/weblinks/trafalgar/img/day-img.jpg',
          extensiontitle: op.opportunity_name,
          extensionsubtitle: op.opportunity_name,
          is_child: true,
        };
      })
      return extensions.filter(e => e.isselected).concat(opportunities);
    },
    availableSailings() {
      const from = this.d.itineraries.fromitinerary;
      const to = this.d.itineraries.toitinerary;
      const sailingdates = this.d.itineraries.sailingdates || [];
      return sailingdates.filter((sailing) => {
        return sailing.date <= from && to <= sailing.enddate;
      });
    },
    mapImage() {
      const image = this.d.itineraries.images.find((image) => image.type === 'map');
      return image ? image.image_url : null;
    },
  },
}
</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './custom-pricing.scss';

.custom-carousel {
  width: 100%;
  overflow: hidden;
  padding: 0 40px;
  box-sizing: border-box;
}

.carousel-track {
  display: flex;
  transition: transform 0.4s ease;
  gap: 20px;
}

.carousel-card {
  min-width: calc(33.333% - 14px);
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  flex-shrink: 0;
}

.carousel-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.title {
  text-align: center;
  margin: 12px 0 4px;
  font-weight: 600;
}

.subtitle {
  text-align: center;
  color: #730179;
  margin-bottom: 16px;
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  background: #ccc;
  border-radius: 50%;
  cursor: pointer;
}

.dot.active {
  background: #730179;
}

/deep/ .table_pricing:not(.custom_pricing) {
  margin: 0 20px;

  .table {
    color: black !important;
    background-color: white !important;

    thead th, table:not(:has(thead)) tbody tr:first-child td {
      color: black !important;
      border-top: solid 4px #A7282EFF !important;
      background-color: #f6f3f2 !important;
    }

    tbody th, tbody td {
      color: black !important;
      background-color: white !important;
    }
  }

  th, td {
    border: solid 1px #e5e7eb !important;
    padding: 12px;
  }
}

</style>

<template>
  <div
    id="menu"
    class="body-page fp-viewing-home body"
    :class="{ 'modal-open': isModalToggle }"
  >
    <main
      class="page-main main-anim scrollpage-container cover_trafalgar"
      id="mainpage"
      v-show="!showCover"
    >
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
      >
        <div class="fullscreen-video-wrap">
          <button
            type="button"
            class="button button-play"
            id="firstPlayVideo"
            @click="playVideo(false)"
          ></button>
          <button
            type="button"
            class="btn btn-link animated fadeIn slow"
            id="firstSkipVideo"
            @click="skipVideo"
          >
            <div>Skip video <IconPlay /></div>
          </button>
          <div class="overlay-home animated fadeIn delay-1s"></div>
          <div
            class="overlay-cover animated fadeIn delay-1s hidePlease"
            data-section="home"
            :style="[ firstOpporunityBackgroundImage != ''
                ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  }
                : {
                    backgroundImage:
                      'url(/weblinks/trafalgar/img/bg-style-1.jpg)'
                  }
            ]"
            id="home"
          ></div>
          <video
            allow="autoplay"
            preload="auto"
            playinline
            id="videoLoop"
            class="animated fadeIn"
            poster="/weblinks/trafalgar/video/video.jpg"
          >
            <source
              src="https://itereo-prod.s3.us-east-2.amazonaws.com/weblink/trafalgar/video/intro.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="section-wrapper animated delay-1s slow fadeIn hidePlease">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description animated fadeIn delay-1s">
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <span v-if="d && d.itineraries"
                        >{{ d.itineraries.fromitinerary | custom-date }} -
                      </span>
                      <span v-if="d && d.itineraries"
                        > {{ d.itineraries.toitinerary | custom-date }}
                      </span>
                      <br>
                      <p class="pt-2"
                        v-if="
                          d &&
                            d.itineraries &&
                            d.itineraries.locations_visited &&
                            Array.isArray(d.itineraries.locations_visited)
                        "
                        >{{
                          d.itineraries.locations_visited
                            | custom-join('name')
                        }}</p
                      >
                    </h1>
                    <div
                      class="cover-header-description-title2"
                      v-if="d && d.itineraries"
                    >
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="d-flex justify-content-start">
                      <p
                        class="cover-header-description-title3"
                        v-if="d && d.properties_opportunity && d.reference_number"
                      >
                        {{ d.reference_number }} |
                      </p>
                      <p class="cover-header-description-title3">
                        <span
                          v-if="
                            d &&
                              d.properties_opportunity &&
                              d.properties_opportunity.id_opportunity_export_type
                          "
                        >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 2
                            "
                            >Trafalgar River</span
                          >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 18
                            "
                            >Custom Group</span
                          >
                        </span>
                      </p>
                    </div>
                    <button
                      id="submit-email"
                      name="submit_email"
                      class="mt-40 mb-100 btn btn-cover btn-outline-white form-success-gone mb-0 animated jackInTheBox delay-1s"
                      @click="toggleCover"
                    >
                      VIEW TRIP
                    </button>
                  </div>
                </div>
                <img
                  class="light-logo logo-responsive animated fadeIn delay-1s"
                  src="/weblinks/trafalgar/img/logo.png"
                  alt="Logo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <header
      class="page-header navbar page-header-drawer menu-right logo-left topmenu-right"
      v-if="showCover"
    >
      <button
        class="navbar-toggler site-menu-icon"
        id="navMenuIcon"
        :class="{ 'menu-visible': isMenuToggle }"
        @click="toggleMenu"
        v-if="showCover"
      >
        <span
          class="menu-icon menu-icon-line"
          :class="{ 'menu-visible': isMenuToggle }"
        >
          <span
            class="text show-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
          ></span>
          <span
            class="text hide-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            ></span
          >
          <div class="bars">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
          </div>
        </span>
      </button>
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img
                class="light-logo"
                src="/weblinks/trafalgar/img/logo.png"
                alt="Logo"
              />
            </span>
          </a>
        </div>
      </div>
      <div
        class="all-menu-wrapper"
        id="navbarMenu"
        :class="{ 'menu-visible': isMenuToggle }"
      >
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <!--<li class="nav-item active">
                <a class="nav-link" href="#home">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>-->
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#letter"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('letter')"
                  >LETTER</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#itinerary"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('itinerary')"
                  >ITINERARY</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#included"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('included')"
                  >INCLUDED</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#map"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('map')"
                  >MAP</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#prices"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('prices')"
                  >PRICING</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#air-contract"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('air-contract')"
                >AIR CONTRACT</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#book"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('book')"
                  >BOOK MY GROUP</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#contact"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('contact')"
                  >CONTACT US</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!--<div class="row secondary_navbar_box_resp justify-content-center fixed-bottom border-top bg-white p-2 d-xl-none mt-2" v-show="showCover"><div class="col-12 animated fadeInUp"><div class="row">
          <div class="col-2 px-1 py-0">
            <a class="text-body text-center" href="#letter" @click.prevent="menuScrollTo('letter')">
            <div class="text-second_nav_resp">
            <i class="fas fa-envelope-open-text"></i>
              Letter
            </div></a>
          </div>
          <div class="col-2 px-1 py-0">
            <a class="text-body text-center" href="">
             <i class="icon fa fa-calendar"></i>
            <div class="text-second_nav_resp">
              Itinerary
            </div></a>
          </div>
          <div class="col-2 px-1 py-0">
            <a class="text-body text-center" href="">
            <div class="text-second_nav_resp">
              highlights
            </div></a>
          </div>
          <div class="col-3 px-1 py-0">
            <a class="text-body text-center" href="">
            <div class="text-second_nav_resp text-success">
              Map
            </div></a>
          </div>
          <div class="col-3 px-1 py-0">
            <a class="text-body text-center" href="">
            <div class="text-second_nav_resp text-success">
              Pricing
            </div></a>
          </div>
        </div>
        </div>
    </div>-->
    <main
      class="page-main main-anim scrollpage-container"
      id="mainpage"
      v-show="showCover"
    >
      <!--BEGIN  HOME -->
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  firstOpporunityBackgroundImage
                )}')`
              }
            : { backgroundImage: 'url(/weblinks/trafalgar/img/bg-style-1.jpg)' }
        ]"
        id="home"
      >
        <div class="overlay-home"></div>
        <!-- style="background-image: url('/weblinks/trafalgar/img/bg-style-1.jpg');" -->
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description">
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <span v-if="d && d.itineraries"
                        >{{ d.itineraries.fromitinerary | custom-date }}  -
                      </span>
                      <span v-if="d && d.itineraries"
                        > {{ d.itineraries.toitinerary | custom-date }}
                      </span>
                      <br>
                      <p class="pt-2"
                        v-if="
                          d &&
                            d.itineraries &&
                            d.itineraries.locations_visited &&
                            Array.isArray(d.itineraries.locations_visited)
                        "
                        >{{
                          d.itineraries.locations_visited
                            | custom-join('name')
                        }}</p
                      >
                    </h1>
                    <div
                      class="cover-header-description-title2"
                      v-if="d && d.itineraries"
                    >
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="d-flex justify-content-start">
                      <p
                        class="cover-header-description-title3"
                        v-if="d && d.properties_opportunity && d.reference_number"
                      >
                        {{ d.reference_number }} |
                      </p>
                      <p class="cover-header-description-title3">
                        <span
                          v-if="
                            d &&
                              d.properties_opportunity &&
                              d.properties_opportunity.id_opportunity_export_type
                          "
                        >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 2
                            "
                            >Trafalgar River</span
                          >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 18
                            "
                            >Custom Group</span
                          >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 33
                            "
                          >Soft Allocation</span
                          >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 34
                            "
                          >Hard Allocation</span
                          >
                          <span
                            v-if="
                              d.properties_opportunity
                                .id_opportunity_export_type === 35
                            "
                          >Charter</span
                          >
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END HOME -->

      <!-- BEING LETTER -->
      <div
        class="section info-area letter_after"
        data-section="letter"
        id="letter"
        v-show="showCover"
      >
        <div class="section-wrapper pb0">
          <div class="single-info row order-mobile">
            <div class="col-lg-6 blockA text-center no-padding info-left">
              <div
                class="img_letter_BG mt-60"
                :style="[ secondOpporunityBackgroundImage.length > 0
                    ? {
                        backgroundImage: `url('${getParsedImageUrl(
                          secondOpporunityBackgroundImage
                        )}')`
                      }
                    : { 'background-image': '/weblinks/brendan-vacations/img/bg-style-1.jpg' }
                ]"
              >
                <!-- <img class="img_letter" src="/weblinks/trafalgar/img/letter.jpg"> -->
              </div>
            </div>
            <div class="col-lg-6 blockB no-padding info-rigth p-4">
              <div class="letter-box">
                <div v-html="d.itineraries.letter_itinerary"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END LETTER -->

      <!-- BEING ITINERARY -->
      <div
        class="section"
        data-section="itinerary"
        id="itinerary"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content  anim">
            <div
              class="col-12 col-lg-12 anim cover-header-description-title2"
            >
              <div class="title-desc">
                <h2 class="h2"><strong>Your</strong><span class="text-italic">
                  Itinerary
                </span></h2>
              </div>
            </div>

            <div class="row row-random grid-media-aside-text fade-3  mx-0">
              <!-- <div class="col-md-6 border-card" v-for="(day, index) in d.itineraries.days" :class="{ inactive: d.itineraries.days }"  :key="index" @click="dayScrollTo(index)"> -->
                <div  v-for="(day, index) in d.itineraries.days" :key="index"
                :class="{
                  'col-md-6 p-0 itinerary__day':
                    index != Object.keys(d.itineraries.days).length - 1 ||
                    (index === Object.keys(d.itineraries.days).length - 1 &&
                      Object.keys(d.itineraries.days).length % 2 === 0),
                  'col-md-12 p-0 itinerary__day':
                    index === Object.keys(d.itineraries.days).length - 1 &&
                    Object.keys(d.itineraries.days).length % 2 !== 0
                }"
                @click="dayScrollTo(index)"
              >
                <div
                  :class="`card gallery-day ${getItineraryDayClassByIndex(index + 1)}`"
                  data-toggle="modal"
                  data-target="#modal-fullscreen"
                >
                  <div class="info">
                  <div class="text-inside">
                    <h1 class="day">Day {{ day.startday }}</h1>
                    <!-- <span>{{ Object.keys(d.itineraries.days).length % 2 != 0 }}</span> -->
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p class="location">
                      <span
                        v-if="
                          day && day.locations && Array.isArray(day.locations)
                        "
                        >{{ day.locations | custom-join('name') }}</span
                      >
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      class="description"
                    >
                      <span
                        v-html="
                          day.textday[0].textday.substring(0, 300) + '...'
                        "
                      ></span>
                      <a
                        href="javascript:void(0)"
                        data-toggle="modal"
                        class="underlineLink showMoreDay"
                        >Show more</a
                      >
                    </p>

                    <p v-if="day.meals" class="meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span class="meals">{{
                        day.meals | custom-join('mealsday')
                      }}</span>
                    </p>
                    <p v-if="day.accommodation" class="hotels">
                      <strong class="mr-1">HOTEL:</strong>
                      <span class="hotels" v-html="day.accommodation"></span>
                    </p>
                  </div>
                  </div>
                  <img
                    v-if="day.url_image_1200_725"
                    :src="day.url_image_1200_725"
                  />
                  <img
                    v-if="!day.url_image_1200_725"
                    src="/weblinks/trafalgar/img/day-img.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END ITINERARY -->

      <!-- BEGIN INCLUDED -->
      <div
        class="section fullscreen-md-off no-footer bg-image info-area"
        data-section="included"
        id="included"
        v-show="showCover"
        v-if="
          (Array.isArray(d.itineraries.highlights) &&
            d.itineraries.highlights.length > 0) ||
            (Array.isArray(d.itineraries.whatsincluded) &&
              d.itineraries.whatsincluded.length > 0) ||
            (Array.isArray(d.itineraries.whatsnotincluded) &&
              d.itineraries.whatsnotincluded.length > 0)
        "
      >
        <div>
          <div class="section-wrapper anim">
            <div class="title-desc title-back mt-40 mb-5">
              <h2 class="h2"><strong>Your</strong><span class="text-italic">
                Inclusions
              </span></h2>
            </div>
            <div class="single-info inclusions__container">
              <div v-if="
                  Array.isArray(d.itineraries.highlights) &&
                  d.itineraries.highlights.length > 0
                "
                style="grid-area: highlights;"
              >
                <div class="info-content info-left card__highlights up-card">
                  <div class="card__highlights__section ">
                    <div
                      v-for="highlight in d.itineraries.highlights"
                      :key="highlight.id"
                    >
                      <p
                        class="card__highlights__title pt-3"
                        v-html="highlight.title"
                      ></p>
                      <ul class="mb-4 mt-4">
                        <li v-for="item in highlight.items" :key="item.id">
                          <div v-if="item.items.indexOf(':') == -1">
                            <strong
                              v-if="
                                item.items.substr(0, item.items.indexOf(' '))
                              "
                              >{{
                                item.items.substr(0, item.items.indexOf(' '))
                              }}</strong
                            >
                            <span
                              v-if="
                                item.items.substr(item.items.indexOf(' ') + 1)
                              "
                            >
                              {{
                                item.items.substr(item.items.indexOf(' ') + 1)
                              }}</span
                            >
                          </div>

                          <div v-else>
                            <span v-if="item.items.split(':').length > 1">
                              <strong v-if="item.items.split(':')[0]"
                                >{{ item.items.split(':')[0] }}:</strong
                              >
                            </span>
                            <span v-else>{{ item.items.split(':')[0] }}</span>
                            <span v-if="item.items.split(':')[1]">
                              {{ item.items.split(':')[1] }}</span
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <picture style="grid-area: picture;">
                <img
                  v-if="thirdOpporunityBackgroundImage != ''"
                  :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`"
                  alt=""
                />
                <img
                  v-else
                  src="/weblinks/trafalgar/img/day-img.jpg"
                  alt=""
                />
              </picture>
              <div
                style="grid-area: included;"
                v-if="
                  Array.isArray(d.itineraries.whatsincluded) &&
                    d.itineraries.whatsincluded.length > 0
                "
              >
                <div
                  class="info-content card__included info-content-left bg-white up-card"
                >
                  <div>
                    <p class="card__included__title">What's included</p>
                    <div class="card__included__content"
                      v-for="whatsinc in d.itineraries.whatsincluded"
                      :key="whatsinc.id"
                    >
                      <h3 v-html="whatsinc.title"></h3>
                      <ul class="mb-4">
                        <li v-for="item in whatsinc.items" :key="item.id">
                          {{ item.items }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-12 p-0" style="grid-area: notincluded;">
                <div>
                  <div
                    class="info-content up-card card-included"
                    v-if="
                      Array.isArray(d.itineraries.whatsnotincluded) &&
                        d.itineraries.whatsnotincluded.length > 0
                    "
                  >
                    <div>
                      <p class="card__notincluded__title">What's Not Included</p>
                      <div class="card__notincluded__content"
                        v-for="whatsnotinc in d.itineraries.whatsnotincluded"
                        :key="whatsnotinc.id"
                      >
                        <h3 v-html="whatsnotinc.title"></h3>
                        <ul class="mb-4">
                          <li v-for="item in whatsnotinc.items" :key="item.id">
                            {{ item.items }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END INCLUDED -->

      <!-- BEGIN EXTENSIONS -->
      <div
        v-if="availableExtensions.length"
        class="section"
        data-section="map"
        id="map"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc mt-40 mb-5">
                  <h2 class="h2"><strong>Your</strong><span class="text-italic">
                    Extensions
                  </span></h2>
                </div>
              </div>

              <div v-for="extension in availableExtensions" class="col-12 col-md-4 px-5 my-3">
                <div class="border-card shadow-sm bg-white" style="border-radius: 12px; overflow: hidden">
                  <img width="100%" style="height: 250px" :src="extension.extensionimage" alt="Deckplan">
                  <p class="center-cell mb-0">
                    {{ extension.extensiontitle }}
                  </p>
                  <p class="center-cell">
                    {{ extension.extensionsubtitle }}
                  </p>
                  <p class="center-cell mb-0">
                    <a @click="toggleExtensionDetailModal(extension)" style="color: inherit">
                      <u>Find out more</u>
                    </a>
                  </p>
                  <div class="p-3 text-center">
                    <button
                      class="btn btn-outline-danger form-success-gone"
                      type="submit"
                      @click="fillQuoteRequest(extension)"
                    >
                      <strong>Easy Quote</strong>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END EXTENSIONS -->

      <!-- BEGIN MAP -->
      <div
        class="section"
        data-section="map"
        id="map"
        v-show="showCover && helpers.validateDisplaySection(data.data.opportunity_settings, exportType, constants.OPPORTUNITY_EXPORT_SECTIONS_IDS.MAP)"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc mt-40 mb-5">
                  <h2 class="h2"><strong>Your</strong><span class="text-italic">
                    Map
                  </span></h2>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <ImageZoom
                    v-if="mapImage"
                    :src="mapImage"
                  />
                  <Map v-else :locations="locationsVisited" innerHeight="46rem"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END MAP -->

      <!-- BEGIN SHIPS -->
      <div
        class="section"
        data-section="map"
        id="map"
        v-show="showCover && helpers.validateDisplaySection(data.data.opportunity_settings, exportType, constants.OPPORTUNITY_EXPORT_SECTIONS_IDS.SHIP_DETAILS)"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc mt-40 mb-5">
                  <h2 class="h2"><strong>Your</strong><span class="text-italic">
                    Ship Details
                  </span></h2>
                </div>
              </div>

              <div v-if="categories.length" class="custom-carousel">
                <div
                  class="carousel-track"
                  :style="{transform: `translateX(-${currentSlide * (100 / 3)}%)`}"
                >
                    <div
                      v-for="item in categories"
                      :key="item.id"
                      class="carousel-card"
                    >
                      <img
                        :src="categoryPhoto(item)"
                        alt="Photo"
                        class="carousel-image"
                      >
                      <p class="title">{{ item.group }}</p>
                      <p class="center-cell mb-0">
                        <a @click="toggleCategoryShipDetailModal(item)" style="color: inherit">
                          <u>Find out more</u>
                        </a>
                      </p>
                    </div>
                </div>
                <div class="carousel-dots">
                  <span
                    v-for="(_, index) in categories.length - 2"
                    :key="index"
                    class="dot"
                    :class="{ active: currentSlide === index }"
                    @click="currentSlide = index"
                  ></span>
                </div>
              </div>

              <div v-for="ship in d.itineraries.ships" class="col-12 col-md-12">
                <div class="center-cell mt-5" style="width: 60%; margin: auto;">
                  <h3 style="font-size: 15px; font-family: 'Noto Serif', 'sans-serif'; font-weight: 700;">
                    {{ ship.title }}:
                  </h3>
                  <p>{{ ship.description }}</p>
                </div>
                <h3 class="center-cell" style="font-size: 15px; font-family: 'Noto Serif', 'sans-serif'; font-weight: 700;">
                  Deckplans:
                </h3>
                <img width="100%" :src="ship.deckplan" alt="Deckplan" style="object-fit: contain">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END SHIPS -->

      <!-- BEGIN PRICES -->
      <div
        class="section fullscreen-md-off no-footer"
        data-section="prices"
        id="prices"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc mt-40 mb-5">
                  <h2 class="h2"><strong>Your</strong><span class="text-italic">
                    Pricing
                  </span></h2>
                </div>
                <div>
                  <div
                    class="white table_pricing"
                    v-html="pricingItinerary"
                    :class="{
                      'custom_pricing': isNewPricing,
                      usa: 244 == d.selling_regions[0].id,
                      'all-regions': 244 != d.selling_regions[0].id
                    }"
                  ></div>
                </div>
                <p class="terms">
                  View
                  <a href="#" @click.prevent="toggleTermsAndConditionsModal(0)"
                    ><strong>Terms and Conditions</strong></a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END PRICES -->

      <!-- BEGIN AIR CONTRACT -->
      <div
        class="section fullscreen-md-off no-footer"
        data-section="air-contract"
        id="air-contract"
        v-show="showCover && d.itineraries.air_contract && helpers.validateDisplaySection(data.data.opportunity_settings, exportType, constants.OPPORTUNITY_EXPORT_SECTIONS_IDS.AIR_CONTRACT)"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc mt-40 mb-5">
                  <h2 class="h2">
                    <span class="text-italic">Air Contract</span>
                  </h2>
                </div>
                <div>
                  <div
                    class="white table_pricing"
                    v-html="d.itineraries.air_contract"
                    :class="{
                      usa: 244 == d.selling_regions[0].id,
                      'all-regions': 244 != d.selling_regions[0].id
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END AIR CONTRACT -->

      <!-- Begin of Book your group section -->
      <div
        class="section pb-5"
        data-section="book"
        id="book"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-6 anim book__content">
                <h2 class="h2"><strong>Quotation</strong><br><span class="text-italic">
                  Offer Acceptance
                </span></h2>
                <div>
                  <button
                    class="pt-4 text-book-signature"
                    :disabled="
                      data.data.request_form.properties_request_form
                        .id_stage_supplier !== 23
                    "
                  >
                    <span class="text-book-disabled">
                      Not activated until Quote Complete
                    </span>
                    <span class="text-book-enabled">
                      If you are happy with our proposal and would like to go
                      ahead please click here.</span
                    >
                  </button>
                  <div
                    class="form-group form-success-gone mb-0 d-flex justify-content-start align-items-center"
                  >
                    <button
                      class="btn btn-outline-white form-success-gone mb-0 ml-2 mt-3 button-book-signature"
                      type="submit"
                      @click.prevent="toggleBookMyGroupModal"
                      :disabled="
                        data.data.request_form.properties_request_form
                          .id_stage_supplier !== 23
                      "
                    >
                      <strong class="text">Book here</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-6 p-0 anim contact-info  fluid contact-border-left"
              >
                <div class="book-image-box">
                  <img
                    v-if="secondOpporunityBackgroundImage != ''"
                    :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                    alt=""
                  />
                  <img
                    v-else
                    src="/weblinks/trafalgar/img/day-img.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BEGIN CONTACT -->
      <div
        class="section section-contact bg-contact pt-5 pb-5"
        data-section="contact"
        id="contact"
        v-show="showCover"
      >
        <div class="bg-overlay">
          <div class="section-wrapper">
            <div class="section-content">
              <div class="row m-0">
                <div
                  class="col-12 col-md-6 anim contact-info contact-info-left p-4"
                >
                  <div class="title-desc">
                    <h2 class="h2"><strong>Contact</strong><span class="text-italic">
                      Us
                    </span></h2>
                  </div>
                  <div class="pt-4">
                    <p
                      class="pt-4 text-center"
                      v-if="!d.firstname_owner && !d.lastname_owner"
                    >
                      Can we help you?
                    </p>
                    <p class="contact__info__name m-0">
                      <span v-if="d.firstname_owner">{{
                        d.firstname_owner
                      }}</span>
                      <span v-if="d.lastname_owner"> {{
                        d.lastname_owner
                      }}</span>
                    </p>
                    <p class="contact__info__phone pt-2">
                      <span v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
                        >1-888-370-2736 Option {{ d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.SCHEDULED ? "1" : d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.CUSTOM ? "2" : "" }}</span
                      >
                      <span
                        v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.GB.id"
                        >+44 20 7620 8996</span
                      >
                      <span v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.AU.id"
                        >1300 780 283</span
                      >
                      <span v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.CA.id"
                        >1-800-346-2830</span
                      >
                      <span
                      v-else-if="d.itineraries.sellingregions[0].id == 209"
                      >+65 6922 5965</span>
                      <span v-else>866 513 1995</span>
                    </p>
                  </div>
                </div>

                <div
                  class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left p-0"
                >
                  <div class="contact-us-box">
                    <div class="title-desc">
                      <h2 class="h2"><strong>Message</strong><span class="text-italic">
                        us Directly
                      </span></h2>
                    </div>
                    <form @submit.prevent="sendContactForm">
                      <div class="form-group ">
                        <input
                          class="form-control-white"
                          type="text"
                          required
                          placeholder="Your Name"
                          v-model="name"
                          :disabled="isSending"
                        />
                      </div>
                      <div class="form-group ">
                        <input
                          class="form-control-white"
                          type="text"
                          required
                          placeholder="Your Email"
                          v-model="email"
                          :disabled="isSending"
                        />
                      </div>
                      <div class="form-group ">
                        <textarea
                          class="form-control-white"
                          type="text"
                          required
                          placeholder="How can we assist you with this group?"
                          cols="10"
                          rows="10"
                          v-model="description"
                          :disabled="isSending"
                        ></textarea>
                      </div>
                      <div
                        class="form-group form-success-gone text-right mb-0 d-flex justify-content-start align-items-center"
                      >
                        <div v-if="isCompleted">{{ message }}</div>
                        <button
                          class="btn btn-outline-white form-success-gone mb-0"
                          type="submit"
                          :disabled="isSending"
                        >
                          <strong class="text" v-if="!isSending">Send</strong>
                          <strong class="text" v-else>Sending</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END CONTACT -->

      <footer v-show="showCover">
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br />
            <img src="/weblinks/trafalgar/img/logo-itp.png" width="80" />
          </div>
          <div class="detail">
            All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal Fullscreen -- EXTENSION DETAIL -->
    <div
      class="modal modal-fullscreenTT fade animated fadeIn show"
      id="modal-extension-detail-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalExtensionDetail }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalExtensionDetail"
    >
      <div class="overlaymd" @click="toggleExtensionDetailModal()"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleExtensionDetailModal()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div v-if="selectedExtension" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-red pt-4 text-center">{{ selectedExtension.extensiontitle }}</h3>
            </div>
            <img width="100%" height="40%" :src="selectedExtension.extensionimage" alt="Extension Image" style="object-fit: contain">
            <ul class="nav nav-tabs py-3" role="tablist">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  role="tab"
                  style="border: none !important;"
                  :class="{ 'active': selectedExtensionTab === tabs.INFO_EXTENSION_TAB }"
                  @click.prevent="selectExtensionTab(tabs.INFO_EXTENSION_TAB)">
                  Information
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  role="tab"
                  style="border: none !important;"
                  :class="{ 'active': selectedExtensionTab === tabs.DAY_EXTENSION_TAB }"
                  @click.prevent="selectExtensionTab(tabs.DAY_EXTENSION_TAB)">
                  Day to Day
                </a>
              </li>
            </ul>
            <div
              v-if="selectedExtensionTab === tabs.INFO_EXTENSION_TAB"
              role="tabpanel"
            >
              <p class="center-cell">
                {{ selectedExtension.extensionsubtitle }}
              </p>
              <p class="cell" v-html="selectedExtension.extensiondetails" />
              <p class="center-cell" v-html="selectedExtension.extensionnotes" />
              <p class="center-cell text-black">
                <strong>{{ getFromPrice(selectedExtension) }}</strong>
              </p>
            </div>
            <div
              v-if="selectedExtensionTab === tabs.DAY_EXTENSION_TAB"
              role="tabpanel"
            >
              <p class="center-cell" v-html="selectedExtension.extensiondaytodaydetails" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Fullscreen -- CATEGORY SHIP DETAIL -->
    <div
      class="modal modal-fullscreenTT fade animated fadeIn show"
      id="modal-ship-detail-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalCategoryDetail }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalCategoryDetail"
    >
      <div class="overlaymd" @click="toggleCategoryShipDetailModal()"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleCategoryShipDetailModal()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div v-if="selectedCategory" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-red pt-4 text-center">{{ selectedCategory.group }}</h3>
            </div>
            <img width="100%" height="40%" :src="categoryPhoto(selectedCategory)" alt="Category Image" style="object-fit: contain">
            <div v-html="selectedCategory.description" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
    <div
      class="modal modal-fullscreenTT fade animated fadeIn show"
      id="modal-terms-and-conditions-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalTermsAndConditionsToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalTermsAndConditionsToggle"
    >
      <div class="overlaymd" @click="toggleTermsAndConditionsModal(modal)"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleTermsAndConditionsModal(modal)"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-red pt-4 text-center">Terms and Conditions</h3>
            </div>
            <div
              class="title-desc anim-4 paddig-container scrollable"
              v-html="termsConditions"
              @scroll="handleTCScroll"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -- MODAL BOOK MY GROUP -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-red pt-4 text-center">Book my group</h3>
            </div>
            <div
              v-if="hasSignature"
              class="mx-5 mb-0 mt-4 alert alert-success"
              role="alert">
              Thank you for confirming this group with us. Please Contact Us if we can assist you further.
            </div>
            <div
              class="title-desc anim-4 py-3">
              <form
                @submit.prevent="handleSaveSignature"
                class="form-gold mt-0 px-5 py-0"
              >
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Your Full Name"
                    v-model="signature.name"
                    :disabled="hasSignature"
                    :class="{ active: signatureName }"
                    @blur="handleInput($event, signature.name)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="No. of seats + No. of TW & SG room type requested. E.g.: 16 pax, 7 Twins + 2 Singles"
                    v-model="signature.number_of_guests"
                    :disabled="hasSignature"
                    :class="{ active: signatureNumber }"
                    @blur="handleInput($event, signature.number_of_guests)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Deposit amount paid"
                    v-model="signature.payment_amount"
                    :disabled="hasSignature"
                    :class="{ active: signaturePayment }"
                    @blur="handleInput($event, signature.payment_amount)"
                  />
                </div>
                <div v-if="signature.user_agent === ''" :class="[ signatureBox ? 'signature-gold box-signature-div active' : 'signature-gold box-signature-div']">
                  <vueSignature
                    ref="signature"
                    :sigOption="option"
                    :w="'100%'"
                    :h="'200px'"
                  ></vueSignature>
                    <button @click="clear" class="button_clear">Clear</button>
                    <button @click="undo" class="button_undo">Undo</button>
                </div>
                <div v-else class="signature-gold">
                  <img
                    class="img-signature"
                    width="100%"
                    v-bind:src="signature.user_agent"
                  />
                </div>
                <p :class="['terms mt-2', { active: signatureCondition }, termConditionsRead ? '' : 'disabled']" v-if="!hasSignature">
                  <input
                    type="checkbox"
                    v-model="signature.accepted_conditions"
                    name=""
                    @blur="handleInput($event, signature.accepted_conditions)"
                  />
                  Accept T&Cs
                  <a
                    href="#"
                    class="color-golden "
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    ><strong>click here</strong></a
                  >
                </p>
                <p class="terms mt-2 hideTerms" v-else>
                  View
                  <a
                    href="#"
                    class="color-golden"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    ><strong>Terms and Conditions</strong></a
                  >
                </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <div v-if="message" class="mr-32 dangerMessage">{{ message }}</div>
                  <button
                    class="btn btn-outline-white form-success-gone mb-0 button-book-signature"
                    type="submit"
                    :disabled="disableButton"
                  >
                    <strong class="text">Confirm</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL BOOK MY GROUP -->

    <!-- Modal -- MODAL SUCCESS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group-success"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupSuccessToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupSuccessToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupSuccessModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div
            class="modal-body d-flex justify-content-center align-items-center"
          >
            <div class="title-desc">
              <img
                class="success-img pt-4"
                src="/weblinks/trafalgar/img/success-img.png"
              />
              <div class="title-desc">
                <h3 class="h2 dark-red pt-4 text-center">
                Success</h3>
              </div>
              <div class="anim-4 text-center pb-4">
                <p>Your information was sent.</p>
                  <p>A
                    <strong class="color-golden">Group Specialist</strong>
                    will make contact with you to<br> re-confirm details by the end of the next business day.
                  </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <button
                    class="btn btn-outline-white form-success-gone mb-0"
                    type="submit"
                    @click="toggleBookMyGroupSuccessModal"
                  >
                    <strong class="text">Ok</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen modalDays fade animated fadeIn show"
      id="modal-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle"
    >
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">
            <div
              class="col-md-12 p-0 section-day p"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days"
              :key="index"
            >
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img
                    v-if="day.url_image_1600_900"
                    :src="day.url_image_1600_900"
                  />
                  <img
                    v-if="!day.url_image_1600_900"
                    src="/weblinks/trafalgar/img/day-img.jpg"
                  />
                  <div class="section_text_overlay">
                    <h1>Day {{ index + 1 }}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">
                  <div class="align-vcenter">
                    <p class="date">
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p class="location mt-2">
                      <span
                        v-if="
                          day && day.locations && Array.isArray(day.locations)
                        "
                        >{{ day.locations | custom-join('name') }}</span
                      >
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      v-html="day.textday[0].textday"
                    ></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation }}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday">
                    <a class="down" href="#section02">
                      <span class="txt"
                        >DAY {{ Number(day.startday) + 1 }}</span
                      >
                    </a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
